import * as yup from 'yup';
import { emailField, INVITED_NAME_MAX, optionalText, phoneNumber, TranslateFn } from '../../library/validationRules';
import ResourcesIds from '../../resources/ResourcesIds';

/**
 * The four things a clinic needs to have somebody on its books, and no more: the rest of
 * what it knows about a patient is asked for on the evaluation, which is a clinical record
 * rather than an account.
 */
export const createAddPatientSchema = (translate: TranslateFn) => yup.object({
    // Deliberately without the allowAdminHandle flag the login form passes: that lets the
    // literal string "admin" through, which is a sign-in handle rather than a mailbox, and
    // an invitation that cannot be delivered is worse than useless.
    emailAddress: emailField(translate),
    // optionalText rather than requiredText: the fields may be blank -- the patient fills
    // in their own name when they claim the account -- but the form always supplies a
    // string, so the inferred type matches AddPatientFormValues instead of widening to
    // string | undefined. INVITED_NAME_MAX mirrors the API's own @Size, which mirrors the
    // column.
    firstName: optionalText(translate, INVITED_NAME_MAX),
    lastName: optionalText(translate, INVITED_NAME_MAX),
    // Already optional by default, and already passes a blank.
    phoneNumber: phoneNumber(translate, ResourcesIds.PHONE_NUMBER_INVALID),
});
